export default "__VITE_ASSET__CfDXkCqa__"